import produce from 'immer';
import { Reducer } from 'redux';

import {
  IImportProcessActionsType,
  IImportProcessState,
  IImportProcessTypes,
} from './types';

const INITIAL_STATE: IImportProcessState = {
  loadingList: false,
  loadingCreate: false,
  loadingGetLatest: false,

  sortOrder: 'desc',
  sortBy: 'createdAt',

  totalImportProcess: 0,

  importProcess: null,
  importProcesses: [],
};

const importProcess: Reducer<IImportProcessState, IImportProcessActionsType> = (
  state = INITIAL_STATE,
  action: IImportProcessActionsType,
) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case IImportProcessTypes.CREATE_IMPORT_PROCESS_REQUEST: {
        draft.loadingCreate = true;
        break;
      }
      case IImportProcessTypes.CREATE_IMPORT_PROCESS_SUCCESS: {
        draft.loadingCreate = false;
        break;
      }
      case IImportProcessTypes.CREATE_IMPORT_PROCESS_FAILURE: {
        draft.loadingCreate = false;
        break;
      }
      case IImportProcessTypes.GET_LATEST_IMPORT_PROCESS_REQUEST: {
        draft.loadingGetLatest = true;
        break;
      }
      case IImportProcessTypes.GET_LATEST_IMPORT_PROCESS_SUCCESS: {
        draft.loadingGetLatest = false;
        draft.importProcess = action.payload.importProcess;
        break;
      }
      case IImportProcessTypes.GET_LATEST_IMPORT_PROCESS_FAILURE: {
        draft.loadingGetLatest = false;
        break;
      }
      default:
    }
  });
};
export default importProcess;
